import styles from '../AdminTools.module.css'
import { useEffect, useState } from 'react'
import { HeaderAlignedInput } from './AdminInputs/HeaderAlignedInput'
import { HeaderAlignedTaBortButton } from './AdminInputs/HeaderAlignedTaBortButton'
import { useDeleteUserCache } from '../../../../fetchData/mutations/adminTools/useDeleteUserCache'

export const DeleteUserCache = () => {
  const [email, setEmail] = useState<string>('')
  const [projectId, setProjectId] = useState<string>('')

  const deleteUserCache = useDeleteUserCache()

  useEffect(() => {
    if (deleteUserCache.data?.success) {
      setEmail('')
      setProjectId('')
    }
  }, [deleteUserCache.data?.success])

  const handleDelete = () => deleteUserCache.mutate({ email, projectId })

  return (
    <div className={styles.formContainer}>
      <h6 className={styles.inputGroupHeader}>Användarcache</h6>

      <HeaderAlignedInput
        label={'E-mail*'}
        inputValue={email}
        handleChange={(e) => setEmail(e.target.value)}
        maxLength={50}
        type={'email'}
      />

      <HeaderAlignedInput
        label={'Projekt-id'}
        inputValue={projectId}
        handleChange={(e) => setProjectId(e.target.value)}
      />

      <HeaderAlignedTaBortButton handleClick={handleDelete} disabled={!email} />
    </div>
  )
}
